import React from 'react';
import styled from 'styled-components';
import * as RDBCase from '../../../services/buildfire/rdb/cases';
import { useReport } from '../../../services/buildfire/rdb/reports';
import { LOADING_STATE } from '../../../util/loading';
import withCase from '../../../util/withCase';
import ExpandingButton from '../../common/ExpandingButton';
import Typography from '../../common/Typography';
import { useDownloadReport } from '../../../context/DownloadReportContext';
import Report from './Report';
import MessageProvider from '../../../context/MessageContext';
import MessageFab from '../../messages/MessageFab';
import { doesCaseHaveUnreadMessage } from '../../../util/case';
import { useFirebase } from '../../../services/firebase';

interface CustomerReportProps extends React.HTMLAttributes<HTMLElement> {
  case: RDBCase.Case;
}

const ButtonContainer = styled.div`
  text-align: center;
`;

const CustomerReport: React.FC<CustomerReportProps> = ({
  case: c,
  ...props
}) => {
  const { currentUser } = useFirebase();
  const { report, loadingStatus: reportLoadingStatus } = useReport(c.id);
  const { downloadReport } = useDownloadReport();
  if (reportLoadingStatus === LOADING_STATE.LOADING) {
    return null;
  }

  if (!report) {
    return (
      <Typography variant="primary" fontSize="24px">
        Report not found for case {c.id}
      </Typography>
    );
  }

  const isUnread = currentUser
    ? doesCaseHaveUnreadMessage(c, currentUser, true)
    : false;
  return (
    <>
      <Report
        case={c}
        report={report}
        clinicName={c.user.displayName}
        clinicEmail={c.user.email}
        isAdmin={false}
      >
        <ButtonContainer>
          <ExpandingButton
            size="large"
            onClick={() => downloadReport(c, report)}
          >
            DOWNLOAD REPORT
          </ExpandingButton>
        </ButtonContainer>
      </Report>

      <MessageProvider>
        <MessageFab unread={isUnread} />
      </MessageProvider>
    </>
  );
};

export default withCase(CustomerReport);
